import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { SignedContractsApiAdapter, type SignedContract } from '../adapters/SignedContractsApiAdapter';

export const useSignedContracts = (email?: string, enabled: boolean = true) => {
  const apiAdapter = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    return new SignedContractsApiAdapter(httpClient);
  }, []);

  const { data, isLoading, error, refetch } = useQuery<SignedContract[]>({
    queryKey: ['signed-contracts', email],
    queryFn: async () => {
      if (!email) {
        throw {
          message: 'El email es obligatorio para buscar contratos firmados',
        };
      }
      const response = await apiAdapter.getSignedContracts(email);
      return response;
    },
    enabled: enabled && !!email,
    staleTime: 5 * 60 * 1000,
  });

  return {
    contracts: data ?? [],
    isLoading,
    error,
    refetch,
  };
};
